import React from 'react'
import { connect } from 'react-redux'
import { actionCreators, ACTIONS } from '@/store/Documentation'
import DocumentationContent from './content'
import { Main, MainTop, MainTopTitle, MainBody, WhiteBox } from '@/components/Layout'
import { localized } from '@/decorators/localized'
import LoadingIndicator from '@/components/LoadingIndicator'
import { TREE_TYPES } from './dataSource'

@localized()
class Documentation extends React.Component {
  state = {
    activeTab: TREE_TYPES.INTERNAL
  }
  componentDidMount () {
    this.props.loadTree()
  }
  renderContent () {
    const { documentation, create, change, edit, localize, locale, rtl } = this.props
    if (documentation.fetching) { return <LoadingIndicator /> }

    return (
      <DocumentationContent
        key={documentation.componentKey}
        localize={localize}
        locale={locale}
        documentation={documentation}
        create={create}
        change={change}
        edit={edit}
        delete={this.props.delete}
        activeTab={this.state.activeTab}
        onActiveTabChange={tab => this.setState({ activeTab: tab })}
        rtl={rtl}
      />
    )
  }
  render () {
    const { localize } = this.props
    return (
      <Main>
        <MainTop>
          <MainTopTitle>{localize('Documentation.DocumentationTitle')}</MainTopTitle>
        </MainTop>

        <MainBody transparent>
          <WhiteBox>
            {this.renderContent()}
          </WhiteBox>
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  documentation: state.documentation,
  ...ownProps
})

const mapDispatchToProps = {
  loadTree: actionCreators.loadTree
}
for (const key in ACTIONS) {
  const actionName = ACTIONS[key]
  mapDispatchToProps[actionName] = actionCreators[actionName]
}
export default connect(mapStateToProps, mapDispatchToProps)(Documentation)



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/documentation/index.js